/**
 * The alias to this folder is main
 *
 * Consider using this file as entry point to the container.
 * Ideally, you should import, bind and register all req  required modules or components from here
 */

export default {
}


